'use client'

// The film festival's button, at its posters (Sam, 4 Nov: "At all posters for the movie night, lets have an action button
// with a drawer that comes up to show about the film festival, the rules and how to submit"). Walk up to the cinema's
// bill, the laundrette window, the wall by the coffee shop or the phone box while the festival's posters are up, and a
// button opens its drawer (FestivalDrawer). Where they hang is lib/festival.js POSTER_SPOTS, off the slots the posters
// hang in; first-person only, as the vending machine's is: it reads the walker's position.

import { useEffect, useState } from 'react'
import useGameStore from '../../stores/gameStore'
import { kawaii } from '../../lib/ui/theme'
import { POSTER_SPOTS, NEAR, FESTIVAL_TITLE, NIGHT_AT, POSTER } from '../../lib/festival'

const POLL_MS = 450
// the posters come down when the night is over
const DOWN_AT = NIGHT_AT + 3 * 3600e3

export function FestivalHud() {
  const [near, setNear] = useState(false)
  const open = useGameStore((s) => s.festivalOpen)
  const setOpen = useGameStore((s) => s.setFestivalOpen)

  useEffect(() => {
    const t = setInterval(() => {
      if (Date.now() > DOWN_AT) { setNear(false); return }
      const pos = useGameStore.getState().playerPosGetter?.()
      if (!pos) { setNear(false); return }
      setNear(POSTER_SPOTS.some((s) => Math.hypot(pos.x - s.x, pos.z - s.z) < NEAR))
    }, POLL_MS)
    return () => clearInterval(t)
  }, [])

  if (!near || open) return null
  // dressed as the poster is (its magenta and its condensed face), so it reads as the festival's and not the town's
  return (
    <div style={{ position: 'fixed', left: '50%', bottom: 132, transform: 'translateX(-50%)', zIndex: 40 }}>
      <button
        type="button"
        onClick={() => setOpen(true)}
        style={{
          display: 'flex', alignItems: 'center', gap: 10, background: '#e0436b', color: '#fff', border: `2.5px solid ${kawaii.ink}`,
          borderRadius: 999, padding: '6px 18px 6px 6px', cursor: 'pointer', boxShadow: kawaii.drop, whiteSpace: 'nowrap',
        }}
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={POSTER} alt="" style={{ width: 30, height: 45, objectFit: 'cover', borderRadius: 4, border: `2px solid ${kawaii.ink}`, background: '#f4e6cc' }} />
        <span style={{ textAlign: 'left', lineHeight: 1.05 }}>
          <span style={{ display: 'block', fontFamily: 'var(--font-poster-condensed), Impact, sans-serif', fontSize: 18, letterSpacing: '0.04em', textTransform: 'uppercase' }}>{FESTIVAL_TITLE}</span>
          <span style={{ display: 'block', fontSize: 12, fontWeight: 800, opacity: 0.9 }}>about it, and entering a film</span>
        </span>
      </button>
    </div>
  )
}
